import React from 'react';
import { Text, View, Whitespace } from '../../components_new/common';
import { inject, observer } from 'mobx-react';
import { observable, action } from 'mobx';
import { query } from '../../core/createApolloClient/createApolloClient.client';
import { getp } from '../../helpers/getProp';
import gql from 'graphql-tag';
import SocialLogin from '../SocialLogin/SocialLogin';
import history from '../../core/history';
import { ValidatePhoneInput } from './ValidatePhoneInput';

const ShieldBLC = '/images/trusted/bl-complete.png';
const ShieldBL = '/images/trusted/bl.png';
const ShieldBRC = '/images/trusted/br-complete.png';
const ShieldBR = '/images/trusted/br.png';
const ShieldTLC = '/images/trusted/tl-complete.png';
const ShieldTL = '/images/trusted/tl.png';
const ShieldTRC = '/images/trusted/tr-complete.png';
const ShieldTR = '/images/trusted/tr.png';

@inject('userStore')
@observer
class TrustItems extends React.Component {
  @observable enteringPhone = false;
  @observable enteringFacebook = false;
  @observable emailResent = false;

  componentDidMount() {
    this.intervalId = setInterval(this.reCheckEmail, 6000);
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  reCheckEmail = () => {
    return this.props.userStore.refreshVerification();
  };

  handleEmail = async () => {
    const res = await query(
      gql`
        query sendConfirmEmail($isMobile: Boolean) {
          ResendConfirmEmail(isMobile: $isMobile) {
            id
            status
          }
        }
      `,
      { isMobile: true },
    );
    console.log('res', res);
    if (getp(res, 'data.ResendConfirmEmail.status')) {
      this.markEmailReset();
    }
  };

  @action
  markEmailReset = () => {
    this.emailResent = true;
  };
  handlePhone = () => {
    this.enteringPhone = true;
  };
  handlePhoneCompleted = () => {
    this.enteringPhone = false;
  };
  handleFacebook = () => {
    this.enteringFacebook = true;
  };
  handleFacebookSuccess = () => {
    this.enteringFacebook = false;
  };
  handleGovernment = () => {
    history.push('/document-verification');
  };

  render() {
    const {
      userStore,
      userStore: { verificationCount },
      inline,
    } = this.props;
    const loc = history.location;

    return (
      <View className={` ${inline ? '' : 'p-mxx'}`}>
        <View className="f-columns">
          <View className="f-rows f-2">
            <View>
              <Text h3>Trusted Yoodlizer</Text>
            </View>
            <View>
              <Text noclip>
                Earn the trusted yoodlizer badge by verifying your
                identification using the services below.
              </Text>
            </View>
          </View>
          <View className="f-rows f-1 f-center-end ml-l">
            <View className="f-columns">
              <img
                src={verificationCount > 2 ? ShieldTLC : ShieldTL}
                width={40}
                height={40}
              />
              <img
                src={verificationCount > 0 ? ShieldTRC : ShieldTR}
                width={40}
                height={40}
              />
            </View>
            <View className="f-columns">
              <img
                src={verificationCount > 2 ? ShieldBLC : ShieldBL}
                width={40}
                height={47}
              />
              <img
                src={verificationCount > 1 ? ShieldBRC : ShieldBR}
                width={40}
                height={47}
              />
            </View>
          </View>
        </View>
        <Whitespace small />
        <View>
          <Text>{verificationCount} out of 3 steps completed</Text>
          <View className="f-columns mt-sxx">
            <View
              className={`w-56 h-10 mr-sxx ${
                verificationCount > 0 ? 'bg-primaryDark' : 'bg-coolGrayLight'
              }`}
            />
            <View
              className={`w-56 h-10 mr-sxx ${
                verificationCount > 1 ? 'bg-primaryDark' : 'bg-coolGrayLight'
              }`}
            />
            <View
              className={`w-56 h-10 mr-sxx ${
                verificationCount > 2 ? 'bg-primaryDark' : 'bg-coolGrayLight'
              }`}
            />
          </View>
        </View>
        <Whitespace small />
        {(this.enteringPhone && (
          <View>
            <Whitespace smaller />
            <ValidatePhoneInput onValidated={this.handlePhoneCompleted} />
          </View>
        )) || (
          <VerificationItem
            title="Phone"
            isVerified={userStore.isPhoneVerified}
            nonVerifiedDesc="Confirm your phone number via SMS"
            verifiedDesc="Your phone number has been verified!"
            onClick={!userStore.isPhoneVerified ? this.handlePhone : null}
            required
          />
        )}
        <VerificationItem
          title="Email"
          isVerified={userStore.isEmailVerified}
          nonVerifiedDesc={
            !this.emailResent ? 'Resend confirmation email' : 'Email sent'
          }
          verifiedDesc="Your email address has been verified!"
          onClick={!userStore.isEmailVerified ? this.handleEmail : null}
        />

        <VerificationItem
          title="Government I.D."
          isVerified={userStore.isIdVerification}
          nonVerifiedDesc="Upload a photo of your government I.D."
          verifiedDesc="Your government I.D. has been verified"
          onClick={!userStore.isIdVerification ? this.handleGovernment : null}
        />
        {!inline && (
          <View>
            <Whitespace />
            <Whitespace />
          </View>
        )}
      </View>
    );
  }
}

export default TrustItems;

class VerificationItem extends React.Component {
  render() {
    const {
      title,
      isVerified,
      nonVerifiedDesc,
      verifiedDesc,
      onClick,
      required = false,
    } = this.props;
    const RequiredC =
      required && !isVerified ? (
        <View className="f-columns f-sc">
          <Text secondary mr={1}>
            Required
          </Text>
          <i className="fas fa-exclamation-circle secondary" />
        </View>
      ) : null;

    return (
      <div
        className="b-0 bb-1 b-coolGrayLight py-mxx pointer"
        onClick={onClick}
      >
        <View className="f-columns f-between-center">
          <View className="f-columns f-sc">
            <Text h6 grayDark ml={1} clickable>
              {title}
            </Text>
          </View>
          <View className="f-columns f-sc" if={isVerified}>
            <Text primaryDark mr={1} clickable>
              Verified
            </Text>
            <i className="fas fa-check-circle primaryDark" />
          </View>
          {RequiredC}
        </View>
        <Whitespace smaller2 />
        <Text grayDark clickable>
          {isVerified ? verifiedDesc : nonVerifiedDesc}
        </Text>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Trust/TrustItems.js